import { Box, Button, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { StyledClientFilterItem } from "views/Tasks/styles";
import { useSearchParams } from "react-router-dom";
import TanInvalidate from "./tan-invalidate";
import TracesInvalidate from "./traces-invalidate";

const TanTraceInvalidate = () => {
  //   const [page, setPage] = useState<number>(0);
  //   const [pageCount, setPageCount] = useState<number>(10);
  //   const [totalCount, setTotalCount] = useState<number>(0);
  //   const [search, setSearch] = useState("");
  //   const { data, isLoading }: ResType = useQuery(
  //     ["invalidate-check", { search: search, limit: pageCount, offset: page * pageCount }],
  //     getClientVerification,
  //     {
  //       onSuccess(res: any) {
  //         setTotalCount(res?.data?.totalCount);
  //       },
  //     }
  //   );

  //   const handleSearch = (e) => {
  //     setSearch(e);
  //     setPage(0);
  //   };

  //   const { mutate: mutate1 } = useMutation(exportTanInvalid, {
  //     onSuccess: (res: any) => {
  //       const arr = new Uint8Array(res.data?.data);
  //       const blob = new Blob([arr], {
  //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       });
  //       const file = window.URL.createObjectURL(blob);
  //       const formattedDateTime = getCurrentFormattedDateTime();

  //       let link = document.createElement("a");
  //       link.href = file;
  //       link.download = `ATOM Pro - Tan Invalid Credentials ${formattedDateTime}.xlsx`;
  //       link.click();
  //       snack.success("Exported Successfully");
  //     },
  //     onError: (err: any) => {
  //       snack.error(err);
  //       snack.error(handleError(err));
  //     },
  //   });

  //   const handleExport = () => {
  //     const data = { search: search, limit: pageCount, offset: page * pageCount };
  //     mutate1(data);
  //   };

  //   return (
  //     <Box m={1}>
  //       <Box display="flex" justifyContent="space-between">
  //         <SearchContainer
  //           minWidth="300px"
  //           value={search}
  //           debounced
  //           placeHolder="Search by  Name | TAN"
  //           onChange={handleSearch}
  //         />
  //         <Button
  //           variant="outlined"
  //           sx={{ marginRight: "20px", marginBottom: "10px" }}
  //           color="secondary"
  //           onClick={handleExport}
  //           startIcon={<FileDownloadOutlinedIcon />}
  //         >
  //           Export
  //         </Button>
  //       </Box>

  //       <Table
  //         sx={{ height: "76vh", mt: 1 }}
  //         pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
  //         data={data?.data?.totalData || []}
  //         columns={columns}
  //         loading={isLoading}
  //         // selection={{ selected, setSelected }}
  //       />
  //     </Box>
  //   );
  // };

  // const Actions = (props: any) => {
  //   const [state, setState] = useState(props?.data?.tanCredentials);
  //   const [open, setOpen] = useState<boolean>(false);
  //   return (
  //     <>
  //       <Box display="flex" gap={1}>
  //         <>
  //           <IconButton onClick={(e) => setOpen(true)}>
  //             <Edit />
  //           </IconButton>
  //         </>
  //       </Box>
  //       <CredentialsEdit open={open} setOpen={setOpen} data={props?.data?.tanCredentials} />
  //     </>
  //   );
  // };

  // let columns = [
  //   {
  //     key: "Category",
  //     title: "Category",
  //     render: (v) => {
  //       return <Typography>{v?.tanCredentials?.client?.category}</Typography>;
  //     },
  //   },
  //   {
  //     key: "id",
  //     title: "Client Name",
  //     render: (rowData: any) => (
  //       <Typography>{rowData?.tanCredentials?.client?.displayName}</Typography>
  //     ),
  //   },
  //   {
  //     key: "id",
  //     title: "Client ID",
  //     render: (rowData: any) => <Typography>{rowData?.tanCredentials?.client?.clientId}</Typography>,
  //   },
  //   {
  //     key: "tanCredentials.tanNumber",
  //     title: "TAN",
  //   },
  //   {
  //     key: "remarks",
  //     title: "Remarks",
  //   },
  //   {
  //     key: "id",
  //     title: "Actions",
  //     render: (rowData: any) => <Actions data={rowData} />,
  //   },
  // ];
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "tan";
  const [active, setActive] = useState(defaultTab);

  useEffect(() => {
    setActive(defaultTab);
  }, [defaultTab]);

  const handleTabChange = (tab: string) => {
    setActive(tab);
    setSearchParams({ tab });
  };

  return (
    <Box pl={1} pr={1} mt={0} pt={0}>
      <Box
        pl={2}
        pr={2}
        mb={0}
        mt={0}
        pt={0}
        pb={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box display="flex" gap="15px" flexWrap="wrap" alignItems="center">
          <StyledClientFilterItem
            variant="body1"
            color="rgba(0,0,0,0.7)"
            active={active === "tan" ? 1 : 0}
            onClick={() => handleTabChange("tan")}
          >
            TAN
          </StyledClientFilterItem>
          <StyledClientFilterItem
            variant="body1"
            color="rgba(0,0,0,0.7)"
            active={active === "traces" ? 1 : 0}
            onClick={() => handleTabChange("traces")}
          >
            Trace
          </StyledClientFilterItem>
        </Box>
      </Box>
      {active === "tan" && <TanInvalidate tab="tan" />}
      {active === "traces" && <TracesInvalidate tab="traces" />}
    </Box>
  );
};

export default TanTraceInvalidate;
